import React from "react";
import { PermissionName } from "../../../clients/graphqlTypes.js";
import { QuoteAnnotationFragment } from "../../features/quote-annotations/QuoteAnnotations.generated.js";
import { WizardContext } from "../../features/documents/useWizardContext.js";

type ProjectQuoteContextType = {
  projectId: string;
  quoteId: string;
  activeWizardContext: WizardContext;
  selectWizardContextButton: React.ReactElement | null;
  hasItemAnyQuestions: (itemId: string) => boolean;
  refetchWizardQuestions: () => Promise<any>;
  viewerPermissions: PermissionName[];
  quoteAnnotations: readonly QuoteAnnotationFragment[];
  dismissAnnotation: (annotationId: string) => void;
  hiddenAnnotationCount: number;
  restoreAnnotations: () => void;
};

export const ProjectQuoteContext = React.createContext<
  ProjectQuoteContextType | undefined
>(undefined);

export const useProjectQuoteContext = () => {
  const context = React.useContext(ProjectQuoteContext);
  if (!context) {
    throw new Error(
      "useProjectQuoteContext must be used within a ProjectQuoteContextProvider"
    );
  }

  return context;
};
